import { vidMap } from './rep-product-data-grouping';
import './rep-product-report-detail.css'
import { serverFetch } from "../../../server";
import { Table, Button, Typography, Collapse, message, Spin } from 'antd';
import { useEffect, useState, useRef } from 'react';
import { useExcelData } from '../rep-excel-data-provider';

function getPaidTotals(items) {
	return items.reduce(
		(acc, item) => {
			const pays = Array.isArray(item.itemsPay) ? item.itemsPay : [];
			acc.quantity += item.quantity || 0;
			acc.summa += item.summa || 0;
			acc.discount += item.discount || 0;
			acc.total += item.total || 0;
			acc.salaryAmount += item.salaryAmount || 0;
			return acc;
		},
		{ quantity: 0, summa: 0, discount: 0, total: 0, salaryAmount: 0}
	);
}
function getColumns(reportType) {
  const baseColumns = [
    { title: 'Дата', dataIndex: 'date', key: 'date' },
    { title: 'ФИО клиента', dataIndex: 'clientName', key: 'clientName' },
    { title: 'Товар', dataIndex: 'productName', key: 'productName' },
  ];

  const abonCols = reportType !== 0
    ? [
        { title: 'Абонемент', dataIndex: 'packetName', key: 'packetName' },
        { title: 'ID абон.', dataIndex: 'packetId', key: 'packetId' },
      ]
    : [];

  const finCols = [
    { title: 'Кол.', dataIndex: 'quantity', key: 'quantity' },
    { title: 'Сумма', dataIndex: 'summa', key: 'summa' },
    { title: 'Скидка', dataIndex: 'discount', key: 'discount' },
    { title: 'Итого', dataIndex: 'total', key: 'total' },
    { title: '% сотр.', dataIndex: 'salaryPercent', key: 'salaryPercent' },
    { title: 'Зарплата', dataIndex: 'salaryAmount', key: 'salaryAmount' },
  ];

  return [...baseColumns, ...abonCols, ...finCols];
}

// Таблица детализации по ячейке из общей таблицы
function DetailTable({ items, reportType }) {
    const columns = [
      { 
        title: 'Дата', 
        dataIndex: 'date', 
        key: 'date', 
        render: (v) => v ? new Date(v).toLocaleDateString('ru-RU') : '' 
      },
      { 
        title: 'ФИО клиента', 
        dataIndex: 'clientName', 
        key: 'clientName',
        render: (n) => n || 'Не указан' 
      },
      { 
        title: 'Товар', 
        dataIndex: 'productName', 
        key: 'productName',
      },
      ...(reportType !== 0 
        ? [{ title: 'Абонемент', dataIndex: 'packetName', key: 'packetName' },
          { title: 'ID абон.', dataIndex: 'packetName', key: 'packetName'}
        ] 
        : []),
      { 
        title: 'Кол.', 
        dataIndex: 'quantity', 
        key: 'quantity', 
        align: 'right', 
        render: (v) => (v || 0).toLocaleString() 
      },
      { 
        title: 'Сумма', 
        dataIndex: 'summa', 
        key: 'summa', 
        align: 'right', 
        render: (v) => (v || 0).toLocaleString() 
      },
      { 
        title: 'Скидка', 
        dataIndex: 'discount', 
        key: 'discount', 
        align: 'right', 
        render: (v) => (v || 0).toLocaleString() 
      },
      { 
        title: 'Итого', 
        dataIndex: 'total', 
        key: 'total', 
        align: 'right', 
        render: (v) => (v || 0).toLocaleString() 
      },
      { 
        title: '% сотр.', 
        dataIndex: 'salaryPercent', 
        key: 'salaryPercent', 
        align: 'right', 
        render: (v) => (v || 0).toLocaleString()
      },
      { 
        title: 'Зарплата', 
        dataIndex: 'salaryAmount', 
        key: 'salaryAmount', 
        align: 'right'
      }
    ];

    const totals = getPaidTotals(items);

      return (
    <Table
      columns={columns}
      dataSource={items}
      pagination={false}
      size="small"
      bordered
      rowKey={(row, idx) => idx}
      summary={() => {
        return (
          <Table.Summary.Row className="group-total-row">
            {columns.map((col, index) => {
              switch (col.dataIndex) {
                case 'quantity':
                  return (
                    <Table.Summary.Cell key={col.key} index={index} align="right">
                      {totals.quantity.toLocaleString()}
                    </Table.Summary.Cell>
                  );
                case 'summa':
                  return (
                    <Table.Summary.Cell key={col.key} index={index} align="right">
                      {totals.summa.toLocaleString()}
                    </Table.Summary.Cell>
                  );
                case 'discount':
                  return (
                    <Table.Summary.Cell key={col.key} index={index} align="right">
                      {(totals.discount || 0).toLocaleString()}
                    </Table.Summary.Cell>
                  );
                case 'total':
                  return (
                    <Table.Summary.Cell key={col.key} index={index} align="right">
                      {totals.total.toLocaleString()}
                    </Table.Summary.Cell>
                  );
                case 'salaryPercent':
                  return (
                    <Table.Summary.Cell key={col.key} index={index} align="right">
                      {'-'}
                    </Table.Summary.Cell>
                  );
                case 'salaryAmount':
                  return (
                    <Table.Summary.Cell key={col.key} index={index} align="right">
                      {totals.salaryAmount.toLocaleString()}
                    </Table.Summary.Cell>
                  );
                default:
                  // Первая колонка — под «ИТОГО:»
                  if (index === 0) {
                    if (reportType === 0) {
                      return (
                        <Table.Summary.Cell key="label" index={0} colSpan={3} className="summary-cell-right">
                          ИТОГО:
                        </Table.Summary.Cell>
                      );
                    }
                    else if (reportType === 1) {
                      return (
                        <Table.Summary.Cell key="label" index={0} colSpan={5} className="summary-cell-right">
                          ИТОГО:
                        </Table.Summary.Cell>
                      );
                    }
                  }
              }
            })}
          </Table.Summary.Row>
        );
      }}
      className="detail-table-no-margin"
    />
  );
}


// Детализация по ячейке: шапка, таблица, итоги
function RepProductReportDetail({ detailData, onClose, filterParams, detailParams, expandedGroups, setExpandedGroups }) {
  const { type: detailType, selectedRowName, reportType } = detailParams || {};
  const { Title } = Typography;
  const { Panel } = Collapse;
  const [loading, setLoading] = useState(false);
  const [remoteData, setRemoteData] = useState(null);

  const prevDetailParamsRef = useRef();

  const getDetails = () => {    
    setLoading(true);
    const queryParams = {...detailParams, ...filterParams};
    serverFetch("report/saleProductsDetail", {method: "GET", queryParams: queryParams})
      .then(data => {
        setRemoteData(Array.isArray(data) ? data : (data?.items || []));
        setLoading(false);
      })
      .catch(e => {
        message.error(e.userMessage);
        setLoading(false);
      });
  };
const { addExcelTable, setExcelData } = useExcelData();

useEffect(() => {
  if (!remoteData) return;

  // Убираем старые таблицы для выбранной строки
  setExcelData(prev =>
    prev.filter(
      t => !t.title?.startsWith(selectedRowName)
    )
  );

  const saleItems = remoteData.filter(item => item.saleType === 0);
  const packetItems = remoteData.filter(item => item.saleType === 1);

   if (saleItems.length) {
    const totals = getPaidTotals(saleItems);
    addExcelTable({
      title: `${selectedRowName} - Товары`,
      columns: getColumns(0),
      data: saleItems,
      summary: [[
        '', '',
        'ИТОГО:',
        totals.quantity,
        totals.summa,
        totals.discount,
        totals.total,
        '-', // salaryPercent
        totals.salaryAmount
      ]],
    });
  }

  if (packetItems.length) {
    const totals = getPaidTotals(packetItems);
    addExcelTable({
      title: `${selectedRowName} - Услуги`,
      columns: getColumns(1),
      data: packetItems,
      summary: [[
        '', '', '', '',
        'ИТОГО:',
        totals.quantity,
        totals.summa,
        totals.discount,
        totals.total,
        '-', // salaryPercent
        totals.salaryAmount
      ]],
    });
  }

}, [remoteData, selectedRowName, addExcelTable, setExcelData]);


  useEffect(() => {
    // Проверяем, изменилось ли значение по сравнению с предыдущим
    if (prevDetailParamsRef.current === undefined ||
      prevDetailParamsRef.current.employeeId !== detailParams.employeeId ||
      prevDetailParamsRef.current.selectedRowName !== detailParams.selectedRowName ||
      prevDetailParamsRef.current.reportType !== detailParams.reportType) {
      getDetails();
    }

  // Обновляем ref текущим значением
  prevDetailParamsRef.current = detailParams;
}, [detailParams]);

  const dataToRender = remoteData ?? detailData;

  // if (!dataToRender) return null;

  return (
    <div>
      {loading ? (
        <div className="report-loading">
          <Spin size="large" />
        </div>
      ) : dataToRender ? (
        <>
          {reportType === null || reportType === undefined ? (
            <>
              <div className="prod-detail report-detail">
                <div className="detail-header">
                  <Title level={4} className="detail-title">
                    Подробно: {selectedRowName} - {'Зарплата'} - {'Товары, услуги'}
                  </Title>
                  <Button onClick={onClose} shape="circle" size="small" className="close-button">×</Button>
                </div>
                <div className="detail-content">
                  <DetailTable
                    className="mult-detail"
                    items={dataToRender.filter(item => item.saleType === 0)}
                    reportType={0}
                  />
                </div>
              </div>
  
              <div className="between-multiple" />
  
              <div className="prod-detail report-detail">
                <div className="detail-header">
                  <Title level={4} className="detail-title">
                    Подробно: {selectedRowName} - {'Зарплата'} - {'Услуги из пакета'}
                  </Title>
                  <Button onClick={onClose} shape="circle" size="small" className="close-button">×</Button>
                </div>
                <div className="detail-content">
                  <DetailTable
                    className="mult-detail"
                    items={dataToRender.filter(item => item.saleType === 1)}
                    reportType={1}
                  />
                </div>
              </div>
            </>
          ) : (
            <div className="prod-detail report-detail">
              <div className="detail-header">
                <Title level={4} className="detail-title">
                  Подробно: {selectedRowName} - {'Зарплата'} - {reportType === 0 ? 'Товары, услуги' : reportType === 1 ? 'Услуги из пакета' : 'Всего'}
                </Title>
                <Button onClick={onClose} shape="circle" size="small" className="close-button">×</Button>
              </div>
              <div className="detail-content">
                <DetailTable items={dataToRender} reportType={reportType} />
              </div>
            </div>
          )}
        </>
      ) : null}
    </div>
  );  
}

export default RepProductReportDetail;